import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed, ref } from "vue";
import {} from "@/api";
import { useObjectStoreStore } from "@/stores/objectStoreStore";
import ObjectStoreSelect from "./ObjectStoreSelect.vue";
import SelectModal from "@/components/Dataset/DatasetStorage/SelectModal.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterObjectStoreLink',
    props: {
        value: null,
        objectStores: null
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faTimes);
        const { getObjectStoreNameById } = useObjectStoreStore();
        const showModal = ref(false);
        function onSelect(objectStoreId) {
            emit("change", objectStoreId);
            showModal.value = false;
        }
        const selectionText = computed(() => {
            if (props.value) {
                return getObjectStoreNameById(props.value);
            }
            else {
                return "(any)";
            }
        });
        return { __sfc: true, props, getObjectStoreNameById, showModal, emit, onSelect, selectionText, FontAwesomeIcon, ObjectStoreSelect, SelectModal };
    }
});
